module.exports = __webpack_public_path__ + "static/media/left.217200a6.svg";